module.exports = __webpack_public_path__ + "static/media/tot-grey.73ca0ad8.svg";